import type { FlexProps } from '@chakra-ui/react';
import { Box, Flex } from '@chakra-ui/react';
import { InfiniteLoader } from '@ui/components/InfiniteLoader';
import { Token } from '@ui/config/token';
import { useUserAgents } from '@ui/hooks/api/useUserAgents';

import { useProfileDrawer } from '../../useProfileDrawer';
import { TokenListRow } from './TokenListRow';

export const TokenList = (props: FlexProps) => {
  const account = useProfileDrawer((s) => s.account);
  const tokenListType = useProfileDrawer((s) => s.tokenListType);

  const _userHoldingRet = useUserAgents({
    type: 'holding',
    account,
  });

  const _userAgentsCreatedRet = useUserAgents({
    type: 'create',
    account,
  });

  const userAgentsRet =
    tokenListType === 'holding' ? _userHoldingRet : _userAgentsCreatedRet;

  return (
    <Flex flexDir="column" px="20px" {...props}>
      <Box overflow="auto">
        <TokenListRow
          hidden={tokenListType === 'create'}
          token={Token.agentFun}
        />
        {userAgentsRet.data?.pages.map((page, pageIndex) => {
          return page.map((item, i) => {
            return <TokenListRow key={`${pageIndex}_${i}`} userAgent={item} />;
          });
        })}
        {userAgentsRet.isInitialLoading ? null : (
          <InfiniteLoader
            hasMore={Boolean(userAgentsRet.hasNextPage)}
            onNext={async () => {
              return userAgentsRet.fetchNextPage();
            }}
          />
        )}
      </Box>
    </Flex>
  );
};
